import axios from "axios";
import React from 'react';


class MemberpayListCashFreeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      customerDetails: '',
      customer_id: this.props.CustomerId,
      contact_person: [],
      vehicle_information: [],
      referral_list: [],
      customer_product: [],
      state1: [],
      tab_id: 1,
      error_customize: 'Network Failed',
      loader_status: false,
      try_again_status: false,
      main_content_status: false,
      referral_convert_points: [],
    };
  }


  setLoaderFunction = () => {

    this.setState({
      loader_status: true,
      try_again_status: false,
      main_content_status: false,
    });
  };
  closeLoaderFuncion = () => {
    this.setState({
      loader_status: false,
      try_again_status: false,
      main_content_status: true,
    });
  };

  enableTryAgain = () => {

    this.setState({
      loader_status: false,
      try_again_status: true,
      main_content_status: false,
    });
  };

  componentDidMount() {
    this.getDataForView();
  }


  async getDataForView() {
    try {
      this.setLoaderFunction()
      const token = localStorage.getItem("token");
      const id = this.props.memberId;
      const [
        { data: edit },

      ] = await Promise.all([
        axios.get(`api/invoice/member/edit/${id}`,  { headers: { authorization: `Bearer ${token}`, Accept: "application/json" } }),

      ]);
      this.setState({
        invoice_number: edit.invoice.invoice_number,
        invoice_date: edit.invoice.invoice_date,
        invoice_due_date: edit.invoice.invoice_due_date,
        invoice_total: edit.invoice.invoice_total,
        invoice_balance_due: edit.invoice.invoice_balance_due,
        house_number: edit.invoice.invoice_house.house_number,
        invoice_state: edit.invoice.invoice_state.name,
        invoice_state_id: edit.invoice.invoice_state.id
      });
      this.closeLoaderFuncion()

    } catch (error) {
      console.error("Error fetching data: ", error);
      this.enableTryAgain()
    }
  }




  tryAgain = () => {

    this.getDataForView()

  }




  render() {

    return (


      <div>

        {/* Advanced Loader Design */}
        {this.state.loader_status && (
                    <div className="h-screen flex items-center justify-center bg-white bg-opacity-50 z-50">
                        <div className="bg-white p-4 rounded-md">
                            <div className="flex items-center justify-center">
                                <div
                                    className="animate-spin rounded-full border-4 border-l-blue-500 border-r-blue-500 border-t-blue-500 border-white-300 h-12 w-12"></div>
                            </div>
                            <p className="text-center mt-4">Loading...</p>
                        </div>
                    </div>
                )}
                {/*loader_status------------------------------------------------------------------------*/}

        {/* Advanced Try Again Design */}
        {this.state.try_again_status && (
          <div className="h-screen top-0 left-0 right-0 bottom-0 flex items-center justify-center bg-white-800 bg-opacity-50 z-50">
            <div className="animate-fadeInUp bg-white p-8 border border-grey-200 rounded-lg shadow-lg text-center">
              <p className="text-red-500 mb-4 font-semibold">{this.state.error_customize}</p>
              <button
                type="button"
                onClick={this.tryAgain}
                className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-500 focus:outline-none focus:ring focus:border-indigo-300 transition-transform transform hover:scale-105"
              >
                Try Again
              </button>
            </div>
          </div>
        )}


        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 mb-3">
          {this.state.main_content_status && (
            <div>
              <h2 className="text-lg font-bold text-gray-900">Due Details</h2>
              <hr className="mt-4 border-gray-300 mb-10" />

              <dl className="grid grid-cols-1 gap-x-3 gap-y-8 sm:grid-cols-3">
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-900">Invoice Number</dt>
                  <dd className="mt-1 text-sm text-gray-900">{this.state.invoice_number}</dd>
                </div>
                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-900">Invoice Date</dt>
                  <dd className="mt-1 text-sm text-gray-900">{this.state.invoice_date}</dd>
                </div>

                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-900">Invoice Due Date</dt>
                  <dd className="float-left mt-1 text-sm text-gray-900">{this.state.invoice_due_date}</dd>
                </div>

                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-900">House Number</dt>
                  <dd className="mt-1 text-sm text-gray-900">{this.state.house_number}</dd>
                </div>

                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-900">Invoice Status</dt>
                  <dd className="mt-1 text-sm">
                    <span style={{
                      color:
                        this.state.invoice_state_id === 2 ? 'green' :
                          this.state.invoice_state_id === 4 ? 'red' :
                            this.state.invoice_state_id === 5 ? 'orange' :
                              'inherit'
                    }}>
                      {this.state.invoice_state}
                    </span>
                  </dd>

                </div>

                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-900">Invoice Total</dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {this.state.invoice_state_id === 5 ? '0.00' : this.state.invoice_total}
                  </dd>
                </div>

                <div className="sm:col-span-1">
                  <dt className="text-sm font-medium text-gray-900">Balance Due</dt>
                  <dd className="mt-1 text-sm text-gray-900">
                    {this.state.invoice_state_id === 5 ? '0.00' : this.state.invoice_balance_due}
                  </dd>
                </div>

              </dl>




              <hr className="mt-8 border-gray-300 mt-10" />


            </div>
          )}
        </div>


      </div>
    )

  }
}

export default MemberpayListCashFreeView;